import { render } from "./filemanager.vue?vue&type=template&id=6878477c"
import script from "./filemanager.vue?vue&type=script&lang=js"
export * from "./filemanager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__